import { useNavigate, useLocation } from "react-router-dom";
import styles from "../assets/css/List.module.css";

const List = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div>
      <div className={styles.list}>
        <div
          onClick={() => navigate("/")}
          className={`${styles.box1} ${
            location.pathname === "/" ? styles.active : ""
          }`}
        >
          <img
            className={styles.icons}
            src="/images/users.svg"
            alt="categories icon"
          />
          <div className={styles.text1}>Пользователи</div>
        </div>
        <div
          onClick={() => navigate("/verification")}
          className={`${styles.box1} ${
            location.pathname === "/verification" ? styles.active : ""
          }`}
        >
          <img
            className={styles.icons}
            src="/images/confirmation.svg"
            alt="users icon"
          />
          <div className={styles.text1}>Верификация пола</div>
        </div>
        <div
          onClick={() => navigate("/requests")}
          className={`${styles.box1} ${
            location.pathname === "/requests" ? styles.active : ""
          }`}
        >
          <img
            className={styles.icons}
            src="/images/taxi.svg"
            alt="genres icon"
          />
          <div className={styles.text1}>Стать водителем</div>
        </div>
        <div
          onClick={() => navigate("/drivers")}
          className={`${styles.box1} ${
            location.pathname === "/drivers" ? styles.active : ""
          }`}
        >
          <img
            className={styles.icons}
            src="/images/drivers.svg"
            alt="genres icon"
          />
          <div className={styles.text1}>Водители</div>
        </div>
        <div
          onClick={() => navigate("/trips")}
          className={`${styles.box1} ${
            location.pathname === "/trips" ? styles.active : ""
          }`}
        >
          <img
            className={styles.icons}
            src="/images/trips.svg"
            alt="genres icon"
          />
          <div className={styles.text1}>Поездки</div>
        </div>
        <div
          onClick={() => navigate("/support")}
          className={`${styles.box1} ${
            location.pathname === "/support" ? styles.active : ""
          }`}
        >
          <img
            className={styles.icons}
            src="/images/support.svg"
            alt="genres icon"
          />
          <div className={styles.text1}>Поддержка</div>
        </div>
        <div
          onClick={() => navigate("/promotions")}
          className={`${styles.box1} ${
            location.pathname === "/promotions" ? styles.active : ""
          }`}
        >
          <img
            className={styles.icons}
            src="/images/promotion.svg"
            alt="genres icon"
          />
          <div className={styles.text1}>Акции</div>
        </div>
        <div
          onClick={() => navigate("/settings")}
          className={`${styles.box1} ${
            location.pathname === "/settings" ? styles.active : ""
          }`}
        >
          <img
            className={styles.icons}
            src="/images/settings.svg"
            alt="genres icon"
          />
          <div className={styles.text1}>Настройки</div>
        </div>
        <div
          onClick={() => navigate("/FAQ")}
          className={`${styles.box1} ${
            location.pathname === "/FAQ" ? styles.active : ""
          }`}
        >
          <img
            className={styles.icons}
            src="/images/FAQ.svg"
            alt="genres icon"
          />
          <div className={styles.text1}>FAQ</div>
        </div>
      </div>
    </div>
  );
};

export default List;
